import * as Yup from 'yup';
/* eslint-disable no-useless-escape */
import {
  zipRegexValidation,
  fullDateRegexValidation,
  phoneNumberRegexValidation
} from 'modules/utils/MaskUtils';
import dayjs from 'dayjs';

export const COVID_SCREENING_PERSONAL_INFO_BODY_1 = `The information you provide is used to locate your Intermountain record and `;

export const COVID_SCREENING_PERSONAL_INFO_BODY_2 = `contact you with test results`;

export const COVID_SCREENING_PERSONAL_INFO_BODY_3 = `. Your mobile phone, email address and insurance will be updated. Contact us at 385-297-6430 if updates are needed to your physical/mailing address.`;

export const COVID_SCREENING_LEGAL_SEX_TEXT = `This is the legal sex marker on your insurance/health record/drivers license, which may differ from your current gender identity.`;

export const SEX_OPTIONS = [
  { label: 'Male', value: 'MALE' },
  { label: 'Female', value: 'FEMALE' },
  { label: 'Both', value: 'BOTH' },
  { label: 'Unknown', value: 'UNKNOWN' }
];

export const RelationShipToSubscriber = [
  { label: 'Self', value: 'Self' },
  { label: 'Spouse', value: 'Spouse' },
  { label: 'Child', value: 'Child' },
  { label: 'Stepchild', value: 'Stepchild' },
  { label: 'Grandchild', value: 'Grandchild' },
  { label: 'Life Partner', value: 'Life Partner' },
  { label: 'Overage Dependent', value: 'Overage Dependent' },
  { label: 'Other', value: 'Other' }
];

export interface SexOptionsType {
  label: string;
  value: string;
}

export interface StateOptionsType {
  label: string;
  value: string;
}

export const submitPersonalInfoValidation = Yup.object().shape({
  userFirstName: Yup.string()
    .max(16, 'Please use 16 characters or less')
    .required('Please enter a valid first name'),
  userMiddleName: Yup.string()
    .max(16, 'Please use 16 characters or less')
    .notRequired(),
  userLastName: Yup.string()
    .max(26, 'Please use 26 characters or less')
    .required('Please enter a valid last name'),
  userDateOfBirth: Yup.string()
    .matches(fullDateRegexValidation, 'Must be exactly 8 digits')
    .required('Please enter a valid date of birth'),
  userSSNDigits: Yup.number()
    .typeError('Please enter valid number')
    .notRequired(),
  userAddressLine1: Yup.string()
    .max(30, 'Please use 30 characters or less')
    .required('Please enter line 1 of your address'),
  userAddressLine2: Yup.string()
    .max(30, 'Please use 30 characters or less')
    .notRequired(),
  userCity: Yup.string()
    .max(34, 'Please use 34 characters or less')
    .required('Please enter a city'),
  userZip: Yup.string()
    .required('Please enter a valid zip code')
    .matches(zipRegexValidation, 'Must be a valid zip'),
  userState: Yup.string().required('Please select valid State'),
  userEmail: Yup.string()
    .required('Please enter a valid email address')
    .email('Please enter a valid email'),
  userCellNumber: Yup.string()
    .required('Please enter a valid phone number')
    .matches(phoneNumberRegexValidation, 'Phone must match format (###) ###-####'),
  userOtherPhoneNumber: Yup.string()
    .notRequired()
    .matches(phoneNumberRegexValidation, 'Phone must match format (###) ###-####')
});

export interface FormValues {
  userFirstName: string;
  userMiddleName: string;
  userLastName: string;
  userDateOfBirth: string;
  userSSNDigits: string;
  userSex: string;
  userAddressLine1: string;
  userAddressLine2: string;
  userCity: string;
  userState: string;
  userZip: string;
  userEmail: string;
  userCellNumber: string;
  userOtherPhoneNumber: string;
}
export const submitSubscriberInfoValidation = Yup.object().shape({
  subscriberFirstName: Yup.string()
    .max(16)
    .matches(/^[a-zA-Z-]*$/, 'No numbers or special characters or space allowed')
    .required('Please enter a valid first name'),
  subscriberMiddleName: Yup.string()
    .max(16)
    .matches(/^[a-zA-Z-]*$/, 'No numbers or special characters or space allowed')
    .notRequired(),
  subscriberLastName: Yup.string()
    .max(26)
    .matches(/^[a-zA-Z-]*$/, 'No numbers or special characters or space allowed')
    .required('Please enter a valid last name'),
  subscriberSex: Yup.string().required('Please select gender'),
  subscriberAddressLine1: Yup.string()
    .max(30)
    .required('Please enter line 1 of your address'),
  subscriberAddressLine2: Yup.string()
    .max(30)
    .notRequired(),
  subscriberCity: Yup.string()
    .max(34)
    .required('Please enter a city'),
  subscriberZip: Yup.string()
    .required('Please enter a valid zip code')
    .matches(zipRegexValidation, 'Must be a valid zip'),
  subscriberEmail: Yup.string()
    .required('Please enter a valid email address')
    .email('Please enter a valid email'),
  subscriberCellNumber: Yup.string()
    .required('Please enter a valid phone number')
    .matches(phoneNumberRegexValidation, 'Phone must match format (###) ###-####'),
  subscriberDateOfBirth: Yup.date().required('Subscriber D.O.B is required')
});

export const submitGuestPersonalInfoValidation = Yup.object().shape({
  userFirstName: Yup.string()
    .max(16, 'Please use 16 characters or less')
    .matches(/^[a-zA-Z-]*$/, 'No numbers or special characters or space allowed')
    .required('Please enter a valid first name'),
  userMiddleName: Yup.string()
    .max(16, 'Please use 16 characters or less')
    .matches(/^[a-zA-Z-]*$/, 'No numbers or special characters or space allowed')
    .notRequired(),
  userLastName: Yup.string()
    .max(26, 'Please use 26 characters or less')
    .matches(/^[a-zA-Z-]*$/, 'No numbers or special characters or space allowed')
    .required('Please enter a valid last name'),
  userDateOfBirth: Yup.string()
    .nullable(true)
    .test('invalid-dob', 'Please enter valid date of birth', function(value: string) {
      return dayjs(value).isValid();
    })
    .test('dob-after-max-date', 'Date should not be after maximal date', function(value: string) {
      return dayjs().isAfter(value);
    })
    .test(
      'test-patient-dob',
      'If your child is less than 2-years-old and having symptoms, call your pediatrician or visit an Intermountain Instacare/Kidscare for evaluation.',
      function(value: string) {
        return dayjs().diff(dayjs(value), 'month') > 24;
      }
    )
    .required('Please enter a valid date of birth'),
  userSSNDigits: Yup.number()
    .typeError('Please enter valid number')
    .notRequired(),
  userAddressLine1: Yup.string()
    .max(30, 'Please use 30 characters or less')
    .required('Please enter line 1 of your address'),
  userAddressLine2: Yup.string()
    .max(30, 'Please use 30 characters or less')
    .notRequired(),
  userCity: Yup.string()
    .max(34, 'Please use 34 characters or less')
    .required('Please enter a city'),
  userZip: Yup.string()
    .required('Please enter a valid zip code')
    .matches(zipRegexValidation, 'Must be a valid zip'),
  userState: Yup.string().required('Please select valid State'),
  userEmail: Yup.string()
    .required('Please enter a valid email address')
    .email('Please enter a valid email'),
  userCellNumber: Yup.string()
    .required('Please enter a valid phone number')
    .matches(phoneNumberRegexValidation, 'Phone must match format (###) ###-####'),
  userOtherPhoneNumber: Yup.string()
    .notRequired()
    .matches(phoneNumberRegexValidation, 'Phone must match format (###) ###-####')
});
